import { useUserOrganizationRole } from '@/hooks/useUserRole';
import { getUserRole } from '@/lib/auth/token';
import { hasPermission, Permission } from '@/lib/roleMapping';
import { ReactNode } from 'react';

interface PermissionGuardProps {
  children: ReactNode;
  permission: Permission;
  fallback?: ReactNode;
}

export function PermissionGuard({
  children,
  permission,
  fallback = null,
}: PermissionGuardProps) {
  const userRole = getUserRole(); // Rôle utilisateur (CLIENT/ADMIN - super admin de la plateforme)
  const userOrganizationRole = useUserOrganizationRole(); // Rôle dans l'organisation (ADMIN, EDITOR, VIEWER)

  // Si l'utilisateur est super admin de la plateforme, il a accès à tout
  if (userRole === 'ADMIN') {
    return <>{children}</>;
  }

  // Sinon, on vérifie les permissions basées sur le rôle dans l'organisation
  // hasPermission vérifie d'abord userRole (super admin), puis userOrganizationRole
  if (!hasPermission(userRole, userOrganizationRole, permission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
